"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _reactApollo = require("react-apollo");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _configuratorApollo = _interopRequireDefault(require("./configurator-apollo"));
var _configurator = require("./configurator.props/configurator.propTypes");
var Configurator = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Configurator, _React$Component);
  function Configurator() {
    return _React$Component.apply(this, arguments) || this;
  }
  Configurator.resourceType = function resourceType() {
    return 'VehicleConfigurator_1_0_0';
  };
  var _proto = Configurator.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      path = _this$props.path,
      config = _this$props.config;
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.ApolloConsumer, null, function (client) {
      return /*#__PURE__*/_react["default"].createElement(_configuratorApollo["default"], {
        theme: theme,
        data: data,
        client: client,
        market: config.market,
        language: config.language,
        path: path
      });
    });
  };
  return Configurator;
}(_react["default"].Component);
Configurator.displayName = 'Configurator';
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(Configurator);
exports["default"] = _default;